import { mapDtoList, optionalNumber, optionalString, requireObject } from './parse.js';

/**
 * Mirrors com.medprompt.content.transcript.TranscriptSegment
 *
 * @typedef {object} TranscriptSegmentData
 * @property {string|null} text
 * @property {string|null} speaker
 * @property {number|null} startSeconds
 * @property {number|null} endSeconds
 */

/**
 * @param {object} raw
 * @returns {TranscriptSegmentData}
 */
export function fromTranscriptSegmentData(raw) {
  const source = requireObject(raw, 'TranscriptSegment');
  return {
    text: optionalString(source.text),
    speaker: optionalString(source.speaker),
    startSeconds: optionalNumber(source.startSeconds),
    endSeconds: optionalNumber(source.endSeconds),
  };
}

/**
 * @param {unknown} raw
 * @returns {TranscriptSegmentData[]}
 */
export function fromTranscriptSegmentDataList(raw) {
  return mapDtoList(raw, 'TranscriptSegment', fromTranscriptSegmentData);
}
